
import React, { useContext } from "react";
import { FaExclamationTriangle, FaShieldAlt, FaChartArea, FaUsers } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './ConsultancyGlobal.css';
import BannerImage from './consultancy_hero.png';

function RiskReduction() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/risk-reduction-consultancy');
    } else {
      navigate('/login', { state: { from: '/booking/risk-reduction-consultancy' } });
    }
  };

  return (
    <div className="consultancy-page">
      <div className="consultancy-max-width">

        {/* --- HERO --- */}
        <div className="consultancy-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Strategic Safety</span>
          <h1 className="hero-title">Risk Reduction Services</h1>
          <p className="hero-subtitle">
            Identify. Assess. Mitigate. Protecting your business resilience through
            proactive risk management.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Get Consulted <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Hierarchy of Controls</h2>
              <p className="article-text">
                We believe in the hierarchy of controls. PPE is the last resort. We aim to:
                <br />1. <strong>Eliminate</strong> the hazard completely.
                <br />2. <strong>Substitute</strong> with a safer alternative.
                <br />3. <strong>Engineer</strong> controls to isolate people from hazard.
                <br />4. <strong>Administrate</strong> through training and signs.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Comprehensive Assessment</h2>
              <p className="article-text">
                From quantitative risk assessments (QRA) to simple job hazard analysis (JHA),
                we provide the tools to map your risk landscape. We look at operational, financial,
                and reputational risks associated with EHS failures.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Business Continuity</h2>
              <p className="article-text">
                Risk reduction is about staying in business. By predicting potential failures—fire,
                chemical spills, or regulatory shutdowns—we help you build robust contingency plans.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Risk Levels</h4>
              <ul className="key-list">
                <li><FaExclamationTriangle className="check-icon" /> High (Immediate Action)</li>
                <li><FaChartArea className="check-icon" /> Medium (Plan Required)</li>
                <li><FaShieldAlt className="check-icon" /> Low (Monitor)</li>
                <li><FaUsers className="check-icon" /> Residual Risk</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Mitigate Risk</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Secure your operations.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default RiskReduction;
